import React, { useRef, useState, useCallback } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/**
 * Gürgençler 2026 BTS (Back-to-School) Medya Planı.
 * Bütçe 1.000.000 ₺ · Temmuz–Ağustos–Eylül (Eylül = Apple lansmanı ÖNCESİ; lansman dönemi HARİÇ).
 * Dağılımlar 2025 BTS gerçekleşeninden (GA4 + Google/Meta Ads, 1 Tem – 30 Eyl 2025) türetilmiştir.
 */

const CHANNELS = [
  { key: 'gsearch', name: 'Google Search', role: 'Hasat · yüksek niyetli arama', platform: 'Google', weight: 0.40 },
  { key: 'gpmax', name: 'Google PMax + Display', role: 'Talep yaratma · remarketing', platform: 'Google', weight: 0.25 },
  { key: 'meta', name: 'Meta · Facebook / Instagram', role: 'Talep yaratma · bilinirlik', platform: 'Meta', weight: 0.35 },
];
const MONTHS = [
  { key: 'tem', name: 'Temmuz', days: 31, weight: 0.10, note: 'BTS ısınma dönemi' },
  { key: 'agu', name: 'Ağustos', days: 31, weight: 0.30, note: 'Okula dönüş ivmesi' },
  { key: 'eyl', name: 'Eylül', sub: '1 – 18 · lansman öncesi', days: 18, weight: 0.60, note: 'BTS zirvesi' },
];


// Sidebar ile birebir aynı platform logoları
const ChannelLogo = ({ platform }) => (
  <img
    src={platform === 'Meta' ? '/6033716.png' : '/google_ads-512.webp'}
    alt={platform === 'Meta' ? 'Meta' : 'Google Ads'}
    className="h-4 w-4 object-contain rounded-sm"
  />
);

export default function GurgenclerBTS2026() {
  const slideRef = useRef(null);
  const [budget, setBudget] = useState(1000000);
  const [exporting, setExporting] = useState(false);

  const fmtCur = (n) => '₺' + Math.round(Number(n)).toLocaleString('tr-TR');
  const fmtInt = (n) => Math.round(Number(n)).toLocaleString('tr-TR');
  const fmtPct = (n) => '%' + Number(n).toLocaleString('tr-TR', { maximumFractionDigits: 1 });

  const chW = CHANNELS.map((c) => ({ ...c, w: c.weight }));
  const moW = MONTHS.map((m) => ({ ...m, w: m.weight }));

  const chAlloc = chW.map((c) => ({ ...c, budget: budget * c.w }));
  const moAlloc = moW.map((m) => ({ ...m, budget: budget * m.w, daily: (budget * m.w) / m.days }));

  const googleBudget = chAlloc.filter((c) => c.platform === 'Google').reduce((s, c) => s + c.budget, 0);
  const metaBudget = chAlloc.filter((c) => c.platform === 'Meta').reduce((s, c) => s + c.budget, 0);

  const exportPdf = useCallback(async () => {
    if (exporting || !slideRef.current) return;
    setExporting(true);
    try {
      const canvas = await html2canvas(slideRef.current, { scale: 2, backgroundColor: '#ffffff', useCORS: true });
      const img = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pw = pdf.internal.pageSize.getWidth();
      const ph = pdf.internal.pageSize.getHeight();
      const m = 8; const w = pw - m * 2; const h = (canvas.height * w) / canvas.width;
      let y = m; let rem = h;
      pdf.addImage(img, 'JPEG', m, y, w, h); rem -= (ph - m * 2);
      while (rem > 0) { pdf.addPage(); y = m - (h - rem); pdf.addImage(img, 'JPEG', m, y, w, h); rem -= (ph - m * 2); }
      pdf.save('Gurgencler_2026_BTS_Medya_Plani.pdf');
    } catch (e) { console.error('PDF export failed:', e); } finally { setExporting(false); }
  }, [exporting]);

  const Stat = ({ label, value, sub, tone = 'gray' }) => {
    const tones = {
      gray: 'border-gray-200 bg-gray-50 text-gray-800',
      blue: 'border-blue-100 bg-blue-50 text-blue-700',
      indigo: 'border-indigo-100 bg-indigo-50 text-indigo-700',
      amber: 'border-amber-100 bg-amber-50 text-amber-700',
    };
    return (
      <div className={`rounded-xl border p-4 ${tones[tone]}`}>
        <span className="text-[10px] font-medium uppercase opacity-70">{label}</span>
        <p className="text-xl font-bold mt-1">{value}</p>
        {sub && <p className="text-[10px] opacity-60 mt-0.5">{sub}</p>}
      </div>
    );
  };

  return (
    <div className="p-4 md:p-6 max-w-5xl mx-auto">
      <div className="flex justify-between items-center mb-3 gap-3">
        <label className="text-xs text-gray-500 flex items-center gap-2">
          Toplam Bütçe (₺)
          <input
            type="number"
            value={budget}
            onChange={(e) => setBudget(Math.max(0, Number(e.target.value) || 0))}
            className="w-36 rounded-lg border border-gray-300 px-2 py-1 text-sm font-semibold text-gray-800"
            step={50000}
          />
        </label>
        <button
          onClick={exportPdf}
          disabled={exporting}
          className="text-white text-sm font-semibold px-4 py-2 rounded-lg shadow-sm disabled:opacity-60"
          style={{ background: '#1d4ed8' }}
        >
          {exporting ? 'PDF Oluşturuluyor…' : 'PDF Olarak İndir'}
        </button>
      </div>

      <div ref={slideRef} className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        {/* Header */}
        <div className="bg-white border-b px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src="/gurgencler-logo.svg" alt="Gürgençler" className="h-10 w-auto object-contain" />
            <div className="h-9 w-px bg-gray-200" />
            <div>
              <p className="text-sm font-bold text-gray-900">2026 Back-to-School Medya Planı</p>
              <p className="text-[10px] text-gray-400">Temmuz – Eylül 2026 · Google &amp; Meta · Bütçe {fmtCur(budget)}</p>
            </div>
          </div>
          <img src="/logoicon_new.png" alt="Glowytics" className="h-8 w-auto object-contain" />
        </div>

        <div className="p-6 space-y-7">
          {/* Lansman hariç notu */}
          <div className="rounded-xl border-l-4 border-amber-400 bg-amber-50 px-4 py-3">
            <p className="text-sm font-bold text-amber-800">Eylül — Apple lansman dönemi plan dışıdır</p>
            <p className="text-xs text-amber-700/90 mt-1 leading-relaxed">
              Plan Temmuz, Ağustos ve Eylül'ün lansman öncesi (1–18) dönemini kapsar. Apple'ın ~19 Eylül itibarıyla
              başlayan lansman penceresi — 2025'te talebi ayrıca yükselten dönem — bilinçli olarak kapsam dışı tutulmuş,
              ayrı bütçe ve kurgu ile ele alınacaktır. Tüm dağılımlar 2025'in lansman hariç gerçekleşen verisine dayanır.
            </p>
          </div>

          {/* Üst KPI */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <Stat label="Toplam Bütçe" value={fmtCur(budget)} sub="Tem + Ağu + Eyl (1–18)" tone="blue" />
            <Stat label="Google Ads" value={fmtCur(googleBudget)} sub={`${fmtPct((googleBudget / budget) * 100)} · Search + PMax`} tone="blue" />
            <Stat label="Meta" value={fmtCur(metaBudget)} sub={`${fmtPct((metaBudget / budget) * 100)} · FB / IG`} tone="indigo" />
            <Stat label="Plan Dönemi" value="1 Tem – 18 Eyl" sub="lansman öncesi, kesintisiz" />
          </div>

          {/* ===== BÜTÇENİN AYLARA DAĞILIMI (hero) ===== */}
          <div>
            <p className="text-base font-bold text-gray-900 mb-1">Bütçenin Aylara Dağılımı</p>
            <p className="text-xs text-gray-500 mb-4">
              Bütçe BTS talep eğrisine paralel olarak Eylül'e doğru kademeli yoğunlaştırılır. Talep okula dönüşle
              birlikte zirveye çıktığı için en büyük dilim Eylül'ün lansman öncesi yarısına yüklenir; günlük tempo
              belirgin biçimde artar.
            </p>

            {/* Büyük aylık kartlar */}
            <div className="grid grid-cols-3 gap-4">
              {moAlloc.map((m) => {
                const hot = m.key === 'eyl';
                return (
                  <div
                    key={m.key}
                    className={`rounded-2xl border p-5 text-center ${hot ? 'border-amber-300 bg-amber-50' : 'border-gray-200 bg-gray-50'}`}
                  >
                    <div className="text-sm font-semibold text-gray-700">{m.name}</div>
                    {m.sub && <div className="text-[10px] text-amber-700/80 font-medium">{m.sub}</div>}
                    <div className={`mt-2 text-5xl font-extrabold tracking-tight ${hot ? 'text-amber-600' : 'text-blue-600'}`}>
                      {fmtPct(m.w * 100)}
                    </div>
                    <div className="mt-2 text-lg font-bold text-gray-900">{fmtCur(m.budget)}</div>
                    <div className="text-[11px] text-gray-400 mt-0.5">~{fmtCur(m.daily)} / gün · {m.days} gün</div>
                  </div>
                );
              })}
            </div>

            {/* Oransal şerit */}
            <div className="mt-4 flex h-12 w-full overflow-hidden rounded-xl ring-1 ring-gray-200">
              {moAlloc.map((m) => {
                const hot = m.key === 'eyl';
                return (
                  <div
                    key={m.key}
                    className={`flex flex-col items-center justify-center text-white ${hot ? 'bg-amber-500' : m.key === 'tem' ? 'bg-blue-600' : 'bg-blue-500'}`}
                    style={{ width: `${m.w * 100}%` }}
                  >
                    <span className="text-sm font-bold leading-none">{fmtPct(m.w * 100)}</span>
                    <span className="text-[10px] opacity-90 leading-none mt-0.5">{m.name}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* ===== KANAL DAĞILIMI ===== */}
          <div>
            <p className="text-base font-bold text-gray-900 mb-3">Kanal Dağılımı</p>
            <div className="overflow-x-auto rounded-xl border border-gray-200">
              <table className="w-full text-xs">
                <thead>
                  <tr className="bg-gray-50 text-gray-500 uppercase text-[10px]">
                    <th className="text-left px-3 py-2.5 font-semibold">Kanal</th>
                    <th className="text-left px-3 py-2.5 font-semibold">Rol</th>
                    <th className="text-right px-3 py-2.5 font-semibold">Pay</th>
                    <th className="text-right px-3 py-2.5 font-semibold">Bütçe</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {chAlloc.map((c) => (
                    <tr key={c.key} className="hover:bg-gray-50">
                      <td className="px-3 py-2.5 font-semibold text-gray-800">
                        <span className="inline-flex items-center gap-2">
                          <ChannelLogo platform={c.platform} />
                          {c.name}
                        </span>
                      </td>
                      <td className="px-3 py-2.5 text-gray-500">{c.role}</td>
                      <td className="px-3 py-2.5 text-right tabular-nums font-semibold">{fmtPct(c.w * 100)}</td>
                      <td className="px-3 py-2.5 text-right tabular-nums font-medium">{fmtCur(c.budget)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="bg-blue-50 font-bold text-gray-800">
                    <td className="px-3 py-2.5" colSpan={2}>TOPLAM</td>
                    <td className="px-3 py-2.5 text-right tabular-nums">%100</td>
                    <td className="px-3 py-2.5 text-right tabular-nums">{fmtCur(budget)}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          {/* ===== KANAL × AY MATRİSİ ===== */}
          <div>
            <p className="text-base font-bold text-gray-900 mb-3">Kanal × Ay Bütçe Matrisi</p>
            <div className="overflow-x-auto rounded-xl border border-gray-200">
              <table className="w-full text-xs">
                <thead>
                  <tr className="bg-gray-50 text-gray-500 uppercase text-[10px]">
                    <th className="text-left px-3 py-2.5 font-semibold">Kanal</th>
                    {moAlloc.map((m) => (
                      <th key={m.key} className="text-right px-3 py-2.5 font-semibold">{m.name}</th>
                    ))}
                    <th className="text-right px-3 py-2.5 font-semibold">Toplam</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {chAlloc.map((c) => (
                    <tr key={c.key} className="hover:bg-gray-50">
                      <td className="px-3 py-2.5 font-semibold text-gray-800">
                        <span className="inline-flex items-center gap-2">
                          <ChannelLogo platform={c.platform} />
                          {c.name}
                        </span>
                      </td>
                      {moAlloc.map((m) => (
                        <td key={m.key} className="px-3 py-2.5 text-right tabular-nums">{fmtCur(c.budget * m.w)}</td>
                      ))}
                      <td className="px-3 py-2.5 text-right tabular-nums font-medium">{fmtCur(c.budget)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="bg-blue-50 font-bold text-gray-800">
                    <td className="px-3 py-2.5">TOPLAM</td>
                    {moAlloc.map((m) => (
                      <td key={m.key} className="px-3 py-2.5 text-right tabular-nums">{fmtCur(m.budget)}</td>
                    ))}
                    <td className="px-3 py-2.5 text-right tabular-nums">{fmtCur(budget)}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          {/* ===== Strateji notu ===== */}
          <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
            <p className="text-sm font-bold text-gray-800">Strateji Notu</p>
            <ul className="text-xs text-gray-600 mt-1.5 space-y-1.5 list-disc pl-4 leading-relaxed">
              <li><strong>Zamanlama:</strong> Bütçe Temmuz %10 · Ağustos %30 · Eylül %60 olarak BTS zirvesine yoğunlaştırılır. Eylül'ün ilk yarısında (lansman öncesi) günlük tempo en yüksek seviyeye çıkar, hasat lansman penceresi açılmadan tamamlanır.</li>
              <li><strong>Kanal kurgusu:</strong> Bütçenin büyük kısmı Google'da tutulur (Google {fmtPct((googleBudget / budget) * 100)} / Meta {fmtPct((metaBudget / budget) * 100)}). Google (Search + PMax) verimliliği belirgin biçimde yüksek olduğu için (2025 ROAS 67x vs 28x) hasat ekseni Google'dır; Meta üst-huni talep yaratma ve bilinirlik rolünde, daha kontrollü bir bütçeyle konumlandırılır.</li>
              <li><strong>Esneklik:</strong> Performansa göre aylar arası ve kanallar arası kaydırma yapılır; talep eğrisi 2025 ile uyumlu izlenir ve günlük tempo buna göre optimize edilir.</li>
            </ul>
          </div>

          {/* Footer */}
          <div className="flex justify-between items-center pt-3 border-t border-gray-100">
            <img src="/gurgencler-logo.svg" alt="Gürgençler" className="h-6 w-auto object-contain" />
            <p className="text-[9px] text-gray-400">{new Date().toLocaleDateString('tr-TR')} · Confidential</p>
            <img src="/logoicon_new.png" alt="Glowytics" className="h-6 w-auto object-contain" />
          </div>
        </div>
      </div>
    </div>
  );
}
